import * as d3 from './lib/d3.js'
import {getWindowWidth, getActiveBreakpointFunc} from './utils/responsive.js'

// load config
const CONFIG = require('json!../config.json')


/*
 * main entry point for render visualization
 *
 * @param {object} opts - options that will override the ones in '../config.json
 *
 */
export default (opts) => {
  // merge options with defaults
  const options = Object.assign({}, CONFIG, opts)

  // set initial breakpoint and make function available
  const getActiveBreakpoint = getActiveBreakpointFunc(options.breakpoints)
  riot.STORE.breakpoint = getActiveBreakpoint(getWindowWidth())
  riot.STORE.getActiveBreakpoint = getActiveBreakpoint

  // mount riot into with options
  riot.mount(options.elementSelector, 'measurement-viz', options)
}



// WEBPACK FOOTER //
// ./src/scripts/render_viz.js